import { Copy, LinkSimple } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

/**
 * RP08 — Affiche le lien d'invitation quand l'e-mail n'est pas parti
 * (envois en pause, e-mail automatique désactivé, échec d'envoi).
 * Remplace l'ancien affichage du mot de passe temporaire.
 * Props : invitation = { user_name?, user_email?, activation_url, message? } | null, onClose
 */
export default function InvitationLinkDialog({ invitation, onClose }) {
  const url = invitation?.activation_url || '';
  const copier = () => {
    try {
      navigator.clipboard.writeText(url);
      toast.success('Lien copié');
    } catch {
      window.prompt("Copiez le lien d'invitation :", url);
    }
  };
  return (
    <Dialog open={!!invitation} onOpenChange={(o) => !o && onClose && onClose()}>
      <DialogContent className="max-w-md" data-testid="invitation-link-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'DM Serif Display, serif' }} className="flex items-center gap-2">
            <LinkSimple size={22} className="text-[#C4773B]" /> Lien d'invitation
          </DialogTitle>
          <DialogDescription>
            L'e-mail n'est pas parti. Transmettez ce lien à la personne : il lui permet de choisir son mot de passe.
          </DialogDescription>
        </DialogHeader>
        {invitation && (
          <div className="space-y-3">
            {(invitation.user_name || invitation.user_email) && (
              <p className="text-sm">
                <strong>{invitation.user_name}</strong>
                {invitation.user_email && <span className="text-[#6B6B6B]"> · {invitation.user_email}</span>}
              </p>
            )}
            <div className="border-2 border-dashed border-[#C4773B] p-3 flex items-center gap-2">
              <code className="font-mono text-xs text-[#1E3A5F] flex-1 break-all" data-testid="invitation-link-value">{url}</code>
              <Button size="sm" variant="outline" onClick={copier} className="rounded-none gap-1" data-testid="invitation-link-copy">
                <Copy size={14} /> Copier
              </Button>
            </div>
            <p className="text-xs text-[#6B6B6B]">Lien personnel, utilisable une seule fois et valable 7 jours.</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
